app.service('login', function (modal, loading, validate, agreementsSubmit, console, passwordInvalid, changeNick, captchaService, emailInvalid) {
	var $loginBox, $loginForm, $registerForm, $remindForm;
	var userUtterance, userEmail, userCallback;

	function remindFormSend() {
		var data = $remindForm.find('input').serializeArray();
		const token = $remindForm.find('[data-toggle="captcha"] .g-recaptcha-response').val() || '';
		addRecaptchaToken(token, data);
		var $errorText = $remindForm.find('.errorText');
		var url = '/password-recovery-form.ltr';
		loading.start();
		$.ajax({
			url: url,
			type: 'POST',
			data: data,
			cache: false,
			success: function (html) {
				loading.stop();
				$remindForm.html(html);
			},
			error: function () {
				loading.stop();
				$errorText.text('Błąd komunikacji. Prosimy spróbować raz jeszcze!');
			}
		});
	}
	function remindFormSuccess() {
		passwordRemindCaptcha();
		validate.task('remindView', function () {
			remindFormSend();
		});
	}

	function passwordRemindCaptcha() {
		const $captcha = $('#password-recovery-captcha');
		if ($captcha.length) {
			captchaService.load($captcha.attr('id'), $captcha.data('place'));
		}
	}

	function registerFormSend(callback) {
		var data = $registerForm.find('input').serializeArray();
		const token = $registerForm.find('[data-toggle="captcha"] .g-recaptcha-response').val();
		addRecaptchaToken(token, data);
		var $errorText = $registerForm.find('.errorText');
		var url = '/layer-registration.ltr?user_utterance=' + userUtterance;
		loading.start();
		$.ajax({
			url: url,
			type: 'POST',
			data: data,
			success: function (json) {
				loading.stop();
				if (json.loginFailed && json.errorMessage !== '') {
					$errorText.html(json.errorMessage);
					addRegistrationCaptcha();
				}
				if (json.loginSuccessful) {
					$loginBox.addClass('success');
					setTimeout(function () {
						checkLogged(function () {
							modal.close();
							callback();
						});
					}, 1000);
				}
			},
			error: function () {
				loading.stop();
				$errorText.text('Błąd komunikacji. Prosimy spróbować raz jeszcze!');
			}
		});
	}
	function addRecaptchaToken(token, data) {
		if (token) {
			data.push({
				name: 'g-recaptcha-response',
				value: token
			});
		}
	}
	function registerFormSuccess(callback) {
		$registerForm.find('input:checkbox').click(function () {
			$registerForm.validate().element($(this));
		});
		agreementsSubmit.init($registerForm, $registerForm.find('input[name=permissionToProcessingAccepted]'));

		changeNick.init();
		validate.task('registerLayer', function () {
			changeNick.check({}, function (status, submit) {
				if (status == 'VALID') {
					$('#login-layer .check').remove();
					registerFormSend(callback);
				}
			});
		});
		emailInvalid.init($('#email-form'), $('#email-invalid-text'), $('#email-form').closest('.row'));
		passwordInvalid.init($('#password'), $('#password').next('.password-invalid'), $('#password').closest('.row'), $('#email-form'));
	}
	function loginFormSend(callback) {
		var data = $loginForm.find('input').serializeArray();
		const token = $loginForm.find('[data-toggle="captcha"] .g-recaptcha-response').val();
		const idCaptcha = $loginForm.find('[data-toggle="captcha"]').attr('id');
		addRecaptchaToken(token, data);
		var $errorText = $loginForm.find('.errorText');
		var url = '/json_j_spring_security_check.ltr';
		loading.start();
		$.ajax({
			url: url,
			type: 'POST',
			data: data,
			success: function (json) {
				loading.stop();
				if (json.loginFailed && json.errorMessage !== '') {
					$errorText.html(json.errorMessage);
					captchaService.reset(idCaptcha);
					addLoginCaptcha();
				}
				if (json.loginSuccessful) {
					$loginBox.addClass('success');
					setTimeout(function () {
						checkLogged(function () {
							modal.close();
							callback();
						});
					}, 1000);
				}
			},
			error: function () {
				loading.stop();
				$errorText.text('Błąd komunikacji. Prosimy spróbować raz jeszcze!');
			}
		});
	}

	function loginFormSuccess(callback) {
		validate.task('loginView', function () {
			loginFormSend(callback);
		});
	}

	function loadLayerSuccess(html, callback) {
		loading.stop();
		modal.generate({
			header: 'Logowanie/Rejestracja',
			content: html,
			id: 'login-modal',
			callbackOpen: function () {
				$loginBox = $('#login-layer');
				$loginForm = $('#loginView-login');
				$registerForm = $('#loginView-register');
				$remindForm = $('#loginView-remind');
				loginFormSuccess(callback);
				registerFormSuccess(callback);
				remindFormSuccess();
				addLoginCaptcha();
				addRegistrationCaptcha();
				$loginMenu = $('.js-menu-item', $loginBox);
				$loginMenu.click(function () {
					$loginBox.removeClass('login-mode register-mode remind-mode');
					$loginBox.addClass($(this).data('mode') + '-mode');
				});
			}
		});
	}
	function addRegistrationCaptcha() {
		let $captcha = $registerForm.find('[data-toggle="captcha"]');
		if ($captcha.length) {
			captchaService.load($captcha.attr('id'), $captcha.data('place'));
		}
	}
	function addLoginCaptcha() {
		let $captcha = $loginForm.find('[data-toggle="captcha"]');
		let username = $loginForm.find('[name="j_username"]').val();
		if ($captcha.length) {
			captchaService.load($captcha.attr('id'), $captcha.data('place'), username);
		}
	}
	function loadLayer(callback) {
		if ($.support.cors) {
			loading.start();
			$.ajax({
				url: '/layer-registration.ltr',
				data: {
					'user_utterance': userUtterance
				},
				success: function (html) {
					loadLayerSuccess(html, callback);
				},
				error: function () {
					loading.stop();
					modal.alert('Wystąpił błąd komunikacji, prosimy spróbować później');
				}
			});
		} else {
			modal.alert('Przestarzała przeglądarka!');
		}
	}
	function checkLogged(callback) {
		loading.start();
		$.ajax({
			url: '/front-user-logged.ltr',
			dataType: 'json',
			success: function (data) {
				loading.stop();
				if (data.logged) {
					callback();
				} else {
					loadLayer(callback);
				}
			},
			error: function () {
				loading.stop();
				modal.alert('Wystąpił błąd komunikacji, prosimy spróbować później');
			}
		});
	}

	function checkUniqueNickSuccess(html, callback) {
		if ($(html).find('div').length) {
			modal.generate({
				header: 'Stwórz unikalny nick',
				content: html,
				id: 'nick-modal',
				callbackOpen: function () {
					changeNick.init({}, function (status, submit) {
						if (status === 'VALID' && submit) {
							modal.close();
							callback();
						}
					});
				}
			});
		} else {
			var status = $.trim(html);
			if (status === 'VALID') {
				callback();
			}
		}
	}
	function checkUniqueNick(callback, utterance) {
		userUtterance = utterance;
		userCallback = callback;
		checkLogged(function () {
			loading.start();
			$.ajax({
				url: '/frontUser-unique-nick.ltr',
				cache: false,
				success: function (html) {
					loading.stop();
					checkUniqueNickSuccess(html, callback);
				},
				error: function () {
					loading.stop();
					modal.alert('Wystąpił błąd komunikacji, prosimy spróbować później');
				}
			});
		});
	}
	function fastOrderLoginFormSendSuccess(url) {
		if (url.indexOf('/simple-login.ltr?login_success') == 0) {
			modal.close();
			loading.start();
			document.location.href = location.pathname;
		} else {
			$('#j_password').addClass('error').val('');
			$('<label class="error">Nieprawidłowe hasło</label>').appendTo($('#j_password').closest('.row'));
			$loginBox.removeClass('loading');
		}
	}
	function fastOrderLoginFormSend() {
		console.log('LOGOWANIE Z WARSTWY');
		$loginBox.addClass('loading');
		loading.start();
		$.ajax({
			url: '/simple_j_spring_security_check.ltr',
			data: {
				j_username: userEmail,
				j_password: $('#j_password').val()
			},
			type: 'POST',
			success: function (url) {
				loading.stop();
				fastOrderLoginFormSendSuccess(url);
			}, error: function () {
				modal.alert('Wystąpił błąd komunikacji, prosimy spróbować później');
			}
		});
	}
	function fastOrderLoginView() {
		$loginBox = $('#login-layer');
		$remindForm = $('#loginView-remind', $loginBox);
		$remindForm.find('input[name=email]').val(userEmail);
		$loginMenu = $('.js-menu-item', $loginBox);
		$loginMenu.click(function () {
			$loginBox.removeClass('login-mode register-mode remind-mode');
			$loginBox.addClass($(this).data('mode') + '-mode');
		});
		validate.task('loginView', function () {
			fastOrderLoginFormSend();
		});
		validate.task('remindView', function () {
			remindFormSend();
		});
	}
	function showLoginLayer(email) {
		console.log('WYŚWIETLENIE WARSTWY Z LOGOWANIEM');
		userEmail = email;
		loading.start();
		$.ajax({
			url: '/simple-login.ltr',
			cache: false,
			data: {
				email: userEmail
			},
			success: function (html) {
				$.scrollTo($('body'));
				modal.generate({
					header: false,
					content: html,
					id: 'login-modal',
					callbackOpen: function () {
						loading.stop();
						fastOrderLoginView();
					}
				});
			}
		});
	}
	return {
		checkUniqueNick: checkUniqueNick,
		showLoginLayer: showLoginLayer
	};
});
